<div class="Rectangle-1347">
  <div class="landing-page-Mobile_v03-1">
    <div class="text-center">
      <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
                  class="img-responsive securenow_logo" alt="Securenow">
    </div>

    <div class="To-book-test-click-next">
      To book test click next
    </div>

    <!-- <div class="Rectangle-1338">
      <div class="container">
        <span class="SecureNow-Silver-Health-Package-81-Parameters">
          Glucose Fasting Test
        </span>

        <div class="Line-1"></div>

        <span class="Includes">
          Includes
        </span>

        <span class="float-right">
          <img src="assets/images/redclifflogo.png" width="100" alt="redcliffe_logo" class="redcliff_logo">
        </span>

        <div style="margin-top: 3%;  margin-bottom: 2%;">
          <span class="sidewidth">8-10 Hrs Fasting Required</span> 
        </div>
      </div>

      <div class="Rectangle-1343">
        <span class="money">
          ₹ 150
        </span>
      </div>
    </div> -->

    <!-- <div class="Rectangle-1338">
      <div class="container">
        <span class="SecureNow-Silver-Health-Package-81-Parameters">
          Glucose Post Prandial Test
        </span>

        <div class="Line-1"></div>

        <span class="Includes">
          Includes
        </span>

        <span class="float-right">
          <img src="assets/images/redclifflogo.png" width="100" alt="redcliffe_logo" class="redcliff_logo">
        </span>

        <div style="margin-top: 3%;  margin-bottom: 2%;">
          <span class="sidewidth">No fasting required</span> 
        </div>
      </div>

      <div class="Rectangle-1343">
        <span class="money">
          ₹ 150
        </span>
      </div>
    </div> -->

    <div class="Rectangle-1338">
      <div class="container">
        <div class="SecureNow-Silver-Health-Package-81-Parameters text-center">
          SecureNow Silver Health Package <br/>
        </div>
        <div class="SecureNow-Silver-Health-Package-81-Parameters1 text-center">
          (81 Parameters)
        </div>

        <div class="Line-1"></div>

        <span class="Includes">
          Includes
        </span>

        <span class="float-right">
          <img src="assets/images/redclifflogo.png" width="100" alt="redcliffe_logo" class="redcliff_logo">
        </span>

        <div style="margin-top: 3%;">
          <p class="sidewidth package_heading">  
            <b>1. COMPLETE HEMOGRAM + ESR (25) · Absolute Basophils Count</b>
          </p>
          <ul>
            <li>Blood · Absolute Eosinophil Count</li>
            <li>Blood · Absolute Lymphocyte Count</li>
            <li>Blood · Absolute Monocyte Count</li>
            <li>Blood · Absolute Neutrophil Count</li>
            <li>Blood · ESR Automated · Hemoglobin Hb · MCH · MCHC <span id="dots"></span>· MCV · MPV Mean Platelet Count Thrombocyte Count · WBC -Total Count Leucocytes · RDW (Red Cell Distribution Width) · Neutrophils · Eosinophils · Lymphocytes · Monocytes · Basophils · RDW – CV · MENTZER INDEX9MCV/RCC · Red Blood Cells – Blood · RDWI · GK Index</li>
          </ul>
          <span id="more">
          <p class="sidewidth package_heading">
            <b>
              2. DIABETES PROFILE · Blood Sugar Fasting<br/><br/>
              3. LIVER FUNCTION TEST -12 · Albumin <br/>
            </b>   
          </p>

          <ul>
            <li>Serum · Alkaline Phosphatase</li>
            <li>Serum · Bilirubin Direct</li>
            <li>Serum · Bilirubin Total</li>
            <li>Serum · GGTP (Gamma GT) · Protein</li>
            <li>Serum · SGOT /AST · SGPT /ALT · Bilirubin -Indirect</li>
            <li>Serum · Globulin · A/G Ratio · SGOT /SGPT Ratio 4. KIDNEY FUNCTION TEST – 10 · BUN Urea Nitrogen        </li>
            <li>Serum · Calcium Total</li>
            <li>Serum · Chlorides</li>
            <li>Serum · Creatinine</li>
            <li>Serum · Phosphorus – Inorganic</li>
            <li>Serum · Sodium</li>
            <li>Serum · Urea</li>
            <li>Serum · Uric Acid</li>
            <li>Serum · BUN /Creatinine Ratio · Urea / Creatinine Ratio 5. LIPID PROFILE - 9 · Cholesterol -total        </li>
            <li>serum · HDL Cholesterol Direct · LDL Cholesterol - Direct · Triglycerides</li>
            <li>Serum · Non -HDL Cholesterol Direct</li>
            <li>Serum · VLDL · LDL/HDL RATIO · CHOL /HDL RATIO · HDL /LDL Cholesterol Ratio 6. THYROID PROFILE -TOTAL (T3</li>
            <li>T4 & TSH ULTRA -SENSITIVE -3 · T3 total Tri Iodothyronine · T4</li>
            <li>Total Thyroxine · TSH Ultra – sensitive 
          </ul>
          
          <p class="sidewidth package_heading">
            <b>
            4. URINE ROUTINE & MICROSCOPY EXTENDED  <br/>
            </b>   
          </p>

          <p class="sidewidth">
            21 · Ph Urine · Specific gravity · Urobilinogen · Color · Transparency · Albumin · Sugar · Blood · Red Blood Cells · Pus Cells (Leukocytes) · Epithelial Cells · Crystals · Cast · Bacteria · Yeast Cells · Nitrate · Urine ketone · Leucocyte Esterase · Bile Pigments (Bilirubin) · Others – Urine · Volume – Urine  
          </p>

        </span>
        </div>
        <button (click)="hideshow1()" id="myBtn" class="Read-more sidewidth">Read more <i class='fa fa-caret-down'></i></button>
      </div>
      <div class="Rectangle-1343">
        <span class="money">
          ₹ 518
        </span>
      </div>
    </div>

    <div class="Rectangle-1338">
      <div class="container">
        <div class="SecureNow-Silver-Health-Package-81-Parameters text-center">
          SecureNow Gold Health Package <br/>
        </div>
        <div class="SecureNow-Silver-Health-Package-86-Parameters text-center">
          Everything in Silver + Iron Test
        </div>

        <div class="Line-1"></div>

        <span class="Includes">
          Includes
        </span>

        <span class="float-right">
          <img src="assets/images/redclifflogo.png" width="100" alt="redcliffe_logo" class="redcliff_logo">
        </span>

        <div style="margin-top: 3%;">
          <p class="sidewidth package_heading">  
            <b>1. COMPLETE HEMOGRAM + ESR (25) · Absolute Basophils Count</b>
          </p>
          <ul>
            <li>Blood · Absolute Eosinophil Count</li>
            <li>Blood · Absolute Lymphocyte Count</li>
            <li>Blood · Absolute Monocyte Count</li>
            <li>Blood · Absolute Neutrophil Count</li>
            <li>Blood · ESR Automated · Hemoglobin Hb · MCH · MCHC <span id="dots2"></span>· MCV · MPV Mean Platelet Volume · PCV Hematocrit · Platelet Count Thrombocyte Count · WBC -Total Count Leucocytes · RDW (Red Cell Distribution Width) · Neutrophils · Eosinophils · Lymphocytes · Monocytes · Basophils · RDW – CV · MENTZER INDEX9MCV/RCC · Red Blood Cells – • Blood · RDWI · GK Index</li>
          </ul>
          <span id="more2">
          <p class="sidewidth package_heading">
            <b>
              2. DIABETES PROFILE · Blood Sugar Fasting · HbA1C (3 months diabetes average) <br/><br/> 
              3. LIVER FUNCTION TEST -12 · Albumin <br/>
            </b>   
          </p>

          <ul>
            <li>Serum · Alkaline Phosphatase</li>
            <li>Serum · Bilirubin Direct</li>
            <li>Serum · Bilirubin Total</li>
            <li>Serum · GGTP (Gamma GT) · Protein</li>
            <li>Serum · SGOT /AST · SGPT /ALT · Bilirubin -Indirect</li>
            <li>Serum · Globulin · A/G Ratio · SGOT /SGPT Ratio 4. KIDNEY FUNCTION TEST – 10 · BUN Urea Nitrogen        </li>
            <li>Serum · Calcium Total</li>
            <li>Serum · Chlorides</li>
            <li>Serum · Creatinine</li>
            <li>Serum · Phosphorus – Inorganic</li>
            <li>Serum · Sodium</li>
            <li>Serum · Urea</li>
            <li>Serum · Uric Acid</li>
            <li>Serum · BUN /Creatinine Ratio · Urea / Creatinine Ratio 5. LIPID PROFILE - 9 · Cholesterol -total        </li>
            <li>serum · HDL Cholesterol Direct · LDL Cholesterol - Direct · Triglycerides</li>
            <li>Serum · Non -HDL Cholesterol Direct</li>
            <li>Serum · VLDL · LDL/HDL RATIO · CHOL /HDL RATIO · HDL /LDL Cholesterol Ratio 6. THYROID PROFILE -TOTAL (T3</li>
            <li>T4 & TSH ULTRA -SENSITIVE -3 · T3 total Tri Iodothyronine · T4</li>
            <li>Total Thyroxine · TSH Ultra – sensitive 7. IRON STUDIES</li>
          </ul>

          <p class="sidewidth package_heading">
            <b>
            4. URINE ROUTINE & MICROSCOPY EXTENDED  <br/>
            </b>   
          </p>
          <p class="sidewidth">
            21 · Ph Urine · Specific gravity · Urobilinogen · Color · Transparency · Albumin · Sugar · Blood · Red Blood Cells · Pus Cells (Leukocytes) · Epithelial Cells · Crystals · Cast · Bacteria · Yeast Cells · Nitrate · Urine ketone · Leucocyte Esterase · Bile Pigments (Bilirubin) · Others – Urine · Volume – Urine.
          </p>

          <p class="sidewidth package_heading">
            <b>5. Iron <br/> </b>   
          </p>
          <ul>
            <li>Serum · TIBS · UIBS</li>
            <li>Serum · Transferrin Saturation
          </ul>
          
        </span>
        </div>
        <button (click)="hideshow2()" id="myBtn2" class="Read-more sidewidth">Read more <i class='fa fa-caret-down'></i></button>
      </div>
      <div class="Rectangle-1343">
        <span class="money">
          ₹ 804
        </span>
      </div>
    </div>

    <div class="Rectangle-1338">
      <div class="container">
        <div class="SecureNow-Silver-Health-Package-81-Parameters text-center">
          SecureNow Platinum Health Package <br/>
        </div>
        <div class="SecureNow-Silver-Health-Package-88-Parameters text-center">
          Everything in Gold + Vitamin Profile
        </div>

        <div class="Line-1"></div>

        <span class="Includes">
          Includes
        </span>

        <span class="float-right">
          <img src="assets/images/redclifflogo.png" width="100" alt="redcliffe_logo" class="redcliff_logo">
        </span>

        <div style="margin-top: 3%;">
          <p class="sidewidth package_heading">
            <b>1. COMPLETE HEMOGRAM + ESR (25) · Absolute Basophils Count</b>  
          </p>
          <ul>
            <li>Blood · Absolute Eosinophil Count</li>
            <li>Blood · Absolute Lymphocyte Count</li>
            <li>Blood · Absolute Monocyte Count</li>
            <li>Blood · Absolute Neutrophil Count</li>
            <li>Blood · ESR Automated · Hemoglobin Hb · MCH · MCHC <span id="dots3"></span>· MCV · MPV Mean Platelet Volume · PCV Hematocrit · Platelet Count Thrombocyte Count · WBC -Total Count Leucocytes · RDW (Red Cell Distribution Width) · Neutrophils · Eosinophils · Lymphocytes · Monocytes · Basophils · RDW – CV · MENTZER INDEX9MCV/RCC · Red Blood Cells –Blood · RDWI · GK Index</li>
          </ul>
          <span id="more3">
          <p class="sidewidth package_heading">   
            <b>
              2. DIABETES PROFILE · Blood Sugar Fasting · HbA1C (3 months diabetes average) <br/><br/>
              3. LIVER FUNCTION TEST -12 · Albumin <br/>
            </b>
          </p>

          <ul>
            <li>Serum · Alkaline Phosphatase</li>
            <li>Serum · Bilirubin Direct</li>
            <li>Serum · Bilirubin Total</li>
            <li>Serum · GGTP (Gamma GT) · Protein</li>
            <li>Serum · SGOT /AST · SGPT /ALT · Bilirubin -Indirect</li>
            <li>Serum · Globulin · A/G Ratio · SGOT /SGPT Ratio 4. KIDNEY FUNCTION TEST – 10 · BUN Urea Nitrogen        </li>
            <li>Serum · Calcium Total</li>
            <li>Serum · Chlorides</li>
            <li>Serum · Creatinine</li>
            <li>Serum · Phosphorus – Inorganic</li>
            <li>Serum · Sodium</li>
            <li>Serum · Urea</li>
            <li>Serum · Uric Acid</li>
            <li>Serum · BUN /Creatinine Ratio · Urea / Creatinine Ratio 5. LIPID PROFILE - 9 · Cholesterol -total        </li>
            <li>serum · HDL Cholesterol Direct · LDL Cholesterol - Direct · Triglycerides</li>
            <li>Serum · Non -HDL Cholesterol Direct</li>
            <li>Serum · VLDL · LDL/HDL RATIO · CHOL /HDL RATIO · HDL /LDL Cholesterol Ratio 6. THYROID PROFILE -TOTAL (T3</li>
            <li>T4 & TSH ULTRA -SENSITIVE -3 · T3 total Tri Iodothyronine · T4</li>
            <li>Total Thyroxine · TSH Ultra – sensitive 7. IRON STUDIES </li>
          </ul>

          <p class="sidewidth package_heading">
            <b>
            4. URINE ROUTINE & MICROSCOPY EXTENDED  <br/>
            </b>   
          </p>
          <p class="sidewidth">
            21 · Ph Urine · Specific gravity · Urobilinogen · Color · Transparency · Albumin · Sugar · Blood · Red Blood Cells · Pus Cells (Leukocytes) · Epithelial Cells · Crystals · Cast · Bacteria · Yeast Cells · Nitrate · Urine ketone · Leucocyte Esterase · Bile Pigments (Bilirubin) · Others – Urine · Volume – Urine
          </p>

          <p class="sidewidth package_heading">
            <b>5. Iron <br/> </b>   
          </p>

          <ul>
            <li>Serum · TIBS · UIBS</li>
            <li>Serum · Transferrin Saturation 
          </ul>

          <p class="sidewidth package_heading">
            <b>
              6. VITAMIN PROFILE - 2 · Vitamin D · Vitamin B12
            </b>   
          </p>
          
        </span>
        </div>
        <button (click)="hideshow3()" id="myBtn3" class="Read-more sidewidth">Read more <i class='fa fa-caret-down'></i></button>
      </div>

      <div class="Rectangle-1343">
        <span class="money">
          ₹ 1208
        </span>
      </div>
    </div>

    <div class="text-center">
      <button (click)="redirectToRedCliffe()" class="Rectangle-1340">Next</button>
    </div>
  </div>
</div>
    
